import "./folderLocation.css";
import Folder from "./Folder";
import addIcon from "../../picture/plus.png";
import searchIcon from "./images/Search.png";
import icon from "./images/SizeFile.png";
import sortingIcon from "./images/Sort.png";
import folderIcon from "./images/folder.png";
import downloadIcon from "./images/DownloadFile.png";
import documentIcon from "../../picture/uploadFolder.png";
import linkIcon from "./images/link-item.png";
import Button from "./Button/Button";
import { useEffect, useRef, useState } from "react";
import UpdateForm from "./UpdateForm";
import Filter from "./Filter/Filter";
import AddForm from "./AddForm";
import SearchForm from "./SearchForm";
import PdfView from "./PdfView/PdfView";
import { useGlobalContext } from "../../../Context/Context";
import FolderModal from "../../../Editor/FolderModal/FolderModal";
import { MobilePDFReader } from "react-read-pdf";
import UndoIcon from "@mui/icons-material/Undo";
import axios from "axios";
import AddDocumentEditor from "./AddDocumentEditor";
import { useStepContext } from "@mui/material";

function FolderLocation({
  location,
  selectedCompany,
  sideBarRef,
  location_input,
  isLandScapeProp,
}) {
  console.log(location, location_input);
  /*  const filesApi = [
    {
      id: 1,
      uploader: "Zikica Petkovic",
      type: "exe",
      size: 12312352,
      date: new Date(),
      title: "Naslov fajla",
      text: "Teskt opcioni koji opisuje fajl",
      data: "",
      fromEditor: false, // bilo u editoru
      intoEditor: false, // trenutno u editoru
    },
    {
      id: 2,
      uploader: "Miljana Stankovic",
      type: "exe",
      size: 57434124,
      date: new Date(),
      title: "Jos jedan naslov fajla",
      text: "Teskt opcioni koji opisuje fajl",
      data: "",
      fromEditor: false, // bilo u editoru
      intoEditor: false, // trenutno u editoru
    },
    {
      id: 3,
      uploader: "Mladen Dubovac",
      type: "exl",
      size: 4576356,
      date: new Date(),
      title: "Treci naslov fajla",
      text: "Teskt opcioni koji opisuje fajl",
      data: "",
      fromEditor: false, // bilo u editoru
      intoEditor: false, // trenutno u editoru
    },
  ];*/
  const onloadScale = useRef();

  const aspectRatioScreen = {
    widthScale: 16,
    heightScale: 9,
  };

  const ASPECT_RATIO_MAIN = 16 / 9;

  const folderSize = 524288000; //MB

  const updateCheckedDefault = {
    file: undefined,
    value: false,
    isAdding: false,
  };

  const { loggedUser } = useGlobalContext();

  const [files, setFiles] = useState([]);
  const [addingDocument, setAddingDocument] = useState(undefined);
  const [newFiles, setNewFiles] = useState([]);
  const [addingChecked, setAddingChecked] = useState(false);
  const [updateChecked, setUpdateChecked] = useState(updateCheckedDefault);
  const [filteringChecked, setFilteringChecked] = useState(0);
  const [searchChecked, setSearchChecked] = useState(false);
  const [sortingSizeChecked, setSortingSizeChecked] = useState(false);
  const [sortingIndexChecked, setSortingIndexChecked] = useState(false);
  const [detailedChecked, setDetailedChecked] = useState(false);
  const [selectedFilterFile, setSelectedFilterFile] = useState(undefined);
  const [showingItems, setShowingItems] = useState([]);
  const [pdfItems, setPdfItems] = useState([]);
  const [folderClicked, setFolderClicked] = useState(false);
  const { adminDocsUrl } = useGlobalContext({});
  const [filterState, setFilterState] = useState({
    startDate: "",
    endDate: "",
    message: { count: 0, value: 0 }, //0 se gasi 1 crveno 2 zeleno
    documents: { count: 0, value: 0 },
    link: { count: 0, value: 0 },
    image: { count: 0, value: 0 },
    category: [],
    people: [],
  });
  const [viewDocument, setViewDocument] = useState({
    id: 0,
    value: false,
    data: "",
    name: "",
  });
  console.log(sideBarRef);
  const width =
    sideBarRef.current !== undefined && sideBarRef.current !== null
      ? sideBarRef.current.getBoundingClientRect().width
      : window.width;
  const height =
    sideBarRef.current !== undefined && sideBarRef.current !== null
      ? sideBarRef.current.getBoundingClientRect().height
      : window.height;
  const aspectRatio = width / height;

  const previousFiles = useRef();
  const previousNewFiles = useRef();

  const { baseUrl } = useGlobalContext();
  const { apiKey } = useGlobalContext();
  const { isIOS, isAndroid } = useGlobalContext();
  const { typeButton } = useGlobalContext();

  console.log(newFiles);
  console.log(files);

  const convertBytes = (bytes) => {
    let returnValue;
    //console.log(parseInt(bytes / Math.pow(1024, 2)));
    let i = 1;
    while (parseInt(bytes / Math.pow(1024, i)) > 1) i++;
    returnValue = Math.round(bytes / Math.pow(1024, i - 1), 2);
    switch (i) {
      case 1:
        returnValue += "B";
        break;
      case 2:
        returnValue += "KB";
        break;
      case 3:
        returnValue += "MB";
        break;
      case 4:
        returnValue += "GB";
        break;
    }
    return returnValue;
  };

  const handleInputDocument = (e) => {
    const currentFile = e.currentTarget.files[0];
    let reader = new FileReader();
    reader.onload = function (d) {
      const newDocument = {
        id: files.length + newFiles.length + 1,
        uploader: loggedUser.name,
        type: currentFile.type.split("/")[1],
        size: currentFile.size,
        date: new Date(),
        title: currentFile.name,
        text: "",
        data: d.currentTarget.result,
        fromEditor: false, // bilo u editoru
        intoEditor: false, // trenutno u editoru
      };
      setAddingDocument(newDocument);
    };
    reader.readAsDataURL(currentFile);
  };

  const handleSearch = (searchTerm) => {
    const newFiles = files.filter((file) => file.title.includes(searchTerm));
    setFiles(newFiles);
    setSearchChecked(false);
  };

  const handleSortSize = () => {
    files.sort((a, b) => {
      if (sortingSizeChecked) return parseInt(a.size) - parseInt(b.size);
      else return parseInt(b.size) - parseInt(a.size);
    });
    setSortingSizeChecked(!sortingSizeChecked);
    setSortingIndexChecked(false);
  };

  const handleSortIndex = () => {
    files.sort((a, b) => {
      if (sortingIndexChecked) return a.id - b.id;
      else return b.id - a.id;
    });
    setSortingIndexChecked(!sortingIndexChecked);
    setSortingSizeChecked(false);
  };

  const deleteFile = async (id, isAdding) => {
    console.log("Brisanje");
    let remainingFiles = [];
    if (isAdding) {
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/deletePendingDocument.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            id,
            location_id: location.location_id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          remainingFiles = newFiles.filter((file) => file.id !== id);
          setNewFiles(remainingFiles);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/deleteDocumentAdmin.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            id,
            location_id: location.location_id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          remainingFiles = files.filter((file) => file.id !== id);
          setFiles(remainingFiles);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleGetDocuments = async () => {
    if (folderClicked) {
      setFiles(previousFiles.current);
      setNewFiles(previousNewFiles.current);
    } else {
      const newlyFiles = files.filter((file) => file.intoEditor);
      setFiles(newlyFiles);
      setNewFiles([]);
    }
    setFolderClicked(!folderClicked);
  };

  const findMemorySize = () => {
    let memory = 0;
    files.forEach((file) => (memory = +file.size));
    return memory;
  };

  const addIntoFiles = async (id) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/location_documents/moveDocument.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          location_document_pending_id: id,
          location_id: location.location_id,
        }
      );
      console.log(data);
      if (data.status === 200) {
        const memory = findMemorySize();
        if (folderSize > memory) {
          const file = newFiles.find((file) => file.id === id);
          setFiles((prev) => [...prev, file]);
          setNewFiles((prev) => prev.filter((file) => file.id !== id));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resize = (width, height, aspect) => {
    const mainContainer = document.querySelector(".folder-app-main");
    let gameHeight, gameWidth;
    onloadScale.current = width / height;
    if (width > height) {
      if (onloadScale.current > aspect) {
        gameHeight = height;
        gameWidth =
          (gameHeight * aspectRatioScreen.widthScale) /
          aspectRatioScreen.heightScale;
      } else {
        gameWidth = width;
        gameHeight =
          (gameWidth * aspectRatioScreen.heightScale) /
          aspectRatioScreen.widthScale;
      }
    } else {
      if (onloadScale.current > 1 / aspect) {
        gameHeight = window.outerHeight;
        gameWidth =
          (gameHeight * aspectRatioScreen.heightScale) /
          aspectRatioScreen.widthScale;
      } else {
        gameWidth = window.outerWidth;
        gameHeight =
          (gameWidth * aspectRatioScreen.widthScale) /
          aspectRatioScreen.heightScale;
      }
    }
    mainContainer.style.width = gameWidth + "px";
    mainContainer.style.height = gameHeight + "px";
  };

  const handleResetView = () => {
    setViewDocument({ id: 0, value: false, data: "", name: "" });
  };

  const typeOfNewDocument = () => {
    const types = newFiles.map((file) => file.type);
    const sameTypes = [...new Set(types)];
    if (sameTypes.length !== 0) return `(${sameTypes.join(",")})`;
  };

  const getSizeOfFile = (isFromFile) => {
    let sizeOfFile = 0;

    if (isFromFile) {
      files.forEach((file) => {
        sizeOfFile += parseInt(file.size);
      });
    } else {
      newFiles.forEach((file) => {
        sizeOfFile += parseInt(file.size);
      });
    }

    return convertBytes(sizeOfFile);
  };

  const getSizeOfNewFile = () => {
    let sizeOfFile = 0;
    files.forEach((file) => {
      sizeOfFile += parseInt(file.size);
    });
    newFiles.forEach((file) => {
      sizeOfFile += parseInt(file.size);
    });

    return sizeOfFile > folderSize;
  };

  const getForChecking = () => {
    let numberOfFiles = 0,
      current;
    newFiles.forEach((newFile) => {
      current = files.find(
        (file) => file.title === newFile.title || file.size === newFile.size
      );
      if (current) numberOfFiles += 1;
    });
    if (numberOfFiles !== 0) return `${numberOfFiles} dokumenata za proveru`;
  };

  const handleSecondBtnClick = () => {
    if (filteringChecked === 0) {
      setNewFiles([]);
      setFilteringChecked(1);
    } else {
      setNewFiles(previousNewFiles.current);
      setFilteringChecked(0);
    }
  };

  useEffect(() => {
    const handleFetchApi = async () => {
      console.log(location);
      console.log(loggedUser);
      console.log(apiKey);
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/getDocumentsAdmin.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            location_id: location.location_id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          setFiles(data.data);
          previousFiles.current = data.data;
        }
      } catch (error) {
        console.log(error);
      }
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/getDocumentsPending.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            location_id: location.location_id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          setNewFiles(data.data);
          previousNewFiles.current = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
    handleFetchApi();
  }, []);

  /*  window.addEventListener("resize", () => {
    resize(window.innerWidth, window.innerHeight, ASPECT_RATIO_MAIN);
    const folderSizeLimiter = window.innerWidth > window.innerHeight ? 8 : 4;
    const mainContainer = document
      .querySelector(".folder-app-main")
      .getBoundingClientRect();
    const folders = document.querySelectorAll(".folder");
    if (folders.length !== 0)
      folders.forEach(
        (folder) =>
          (folder.style.height = `${
            mainContainer.height / folderSizeLimiter
          }px`)
      );
    const filterFolders = document.querySelectorAll(".filter-folder");
    if (filterFolders.length !== 0) {
      filterFolders.forEach(
        (folder) =>
          (folder.style.height = `${
            mainContainer.height / folderSizeLimiter
          }px`)
      );
    }
  });*/

  /* useEffect(() => {
    //resize(window.outerWidth, window.outerHeight, ASPECT_RATIO_MAIN);
    if (files.length > 0 || newFiles.length > 0) {
      const folderSizeLimiter = window.innerWidth > window.innerHeight ? 8 : 4;
      const mainContainer = document
        .querySelector(".folder-app-main")
        .getBoundingClientRect();
      const folders = document.querySelectorAll(".folder");
      if (folders.length !== 0)
        folders.forEach(
          (folder) =>
            (folder.style.height = `${
              mainContainer.height / folderSizeLimiter
            }px`)
        );
      const filterFolders = document.querySelectorAll(".filter-folder");
      if (filterFolders.length !== 0) {
        filterFolders.forEach(
          (folder) =>
            (folder.style.height = `${
              mainContainer.height / folderSizeLimiter
            }px`)
        );
      }
    }
  }, [files, newFiles, filteringChecked, detailedChecked]);
*/

  return (
    <div className="folder-app">
      {detailedChecked ? (
        <PdfView
          setDetailedChecked={setDetailedChecked}
          selectedFilterFile={selectedFilterFile}
          setSelectedFilterFile={setSelectedFilterFile}
          setFilteringChecked={setFilteringChecked}
          setAddingDocument={setAddingDocument}
          setAddingChecked={setAddingChecked}
          setShowingItems={setShowingItems}
          showingItems={pdfItems}
          location={location}
          locationn_input={location_input}
          selectedCompany={selectedCompany}
          filterState={filterState}
        />
      ) : (
        <div
          className={
            aspectRatio < 1 ? "folder-app-main portrait" : "folder-app-main"
          }
        >
          {filteringChecked === 2 ? (
            <Filter
              setFilteringChecked={setFilteringChecked}
              setAddingChecked={setAddingChecked}
              setDetailedChecked={setDetailedChecked}
              setSelectedFilterFile={setSelectedFilterFile}
              location={location}
              showingItems={showingItems}
              setShowingItems={setShowingItems}
              filterState={filterState}
              setFilterState={setFilterState}
              setPdfItems={setPdfItems}
              location_input={location_input}
              aspectRatio={isLandScapeProp}
            />
          ) : (
            <>
              <div
                className={
                  aspectRatio < 1
                    ? "folder-app-header portrait"
                    : "folder-app-header"
                }
              >
                <div
                  className={
                    aspectRatio < 1
                      ? "folder-app-header-part portrait"
                      : "folder-app-header-part"
                  }
                >
                  {updateChecked.value ? ( // azuriranje
                    <UpdateForm
                      updateChecked={updateChecked}
                      setUpdateChecked={setUpdateChecked}
                      setFiles={setFiles}
                      setNewFiles={setNewFiles}
                      location={location}
                    />
                  ) : addingDocument !== undefined ? ( // dodavanje
                    <AddForm
                      addingDocument={addingDocument}
                      setAddingDocument={setAddingDocument}
                      setNewFiles={setNewFiles}
                      setAddingChecked={setAddingChecked}
                      location={location}
                    />
                  ) : searchChecked ? (
                    <SearchForm handleSearch={handleSearch} />
                  ) : (
                    <>
                      <div
                        className={
                          aspectRatio < 1 ? "add-button portrait" : "add-button"
                        }
                        onClick={() => setAddingChecked(!addingChecked)}
                      >
                        <Button image={addIcon} active={addingChecked} />
                      </div>
                      <div
                        className={
                          aspectRatio < 1
                            ? "info-header portrait"
                            : "info-header"
                        }
                      >
                        {addingChecked ? (
                          <>
                            <label
                              className="info-header-download"
                              htmlFor="file-upload"
                            >
                              <div className="upload-button">
                                <img src={downloadIcon} alt="" />
                              </div>
                            </label>
                            <input
                              id="file-upload"
                              type="file"
                              onChange={handleInputDocument}
                            />
                            <div
                              className={
                                aspectRatio < 1
                                  ? "add-button portrait"
                                  : "add-button"
                              }
                              onClick={() => handleSecondBtnClick()}
                            >
                              <Button image={documentIcon} />
                              <div
                                className={
                                  aspectRatio < 1 ? "circle portrait" : "circle"
                                }
                              >
                                <span>88</span>
                              </div>
                            </div>
                            <div
                              className={
                                aspectRatio < 1
                                  ? "add-button portrait"
                                  : "add-button"
                              }
                              onClick={() => setFilteringChecked(2)}
                            >
                              <Button image={linkIcon} />
                              <div
                                className={
                                  aspectRatio < 1 ? "circle portrait" : "circle"
                                }
                              >
                                <span>88</span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="info-blank">
                            <div className="top-admin">
                              <span>{files.length}</span>
                              <span>
                                {newFiles.length} novih dokumenata
                                {typeOfNewDocument()}
                              </span>
                              <span>{getSizeOfFile(true)} </span>
                            </div>
                            <div className="middle-admin">
                              <span className="middle-admin-correct">
                                {getSizeOfNewFile() &&
                                  `${newFiles.length}
                           novih dokumenata ${typeOfNewDocument()}`}
                              </span>
                              <span>{getSizeOfFile(false)}</span>
                            </div>
                            <div className="bottom-admin">
                              <span style={{ color: "gray" }}>
                                {getForChecking()}
                              </span>
                              <span style={{ color: "green" }}>
                                {convertBytes(folderSize)}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div
                  className={
                    aspectRatio < 1
                      ? "folder-app-header-part portrait"
                      : "folder-app-header-part"
                  }
                >
                  <div
                    className={
                      aspectRatio < 1 ? "add-button portrait" : "add-button"
                    }
                    onClick={() => setSearchChecked(!searchChecked)}
                  >
                    <Button active={searchChecked} image={searchIcon} />
                  </div>
                  <div
                    className={
                      aspectRatio < 1 ? "add-button portrait" : "add-button"
                    }
                    onClick={handleSortSize}
                  >
                    <Button active={sortingSizeChecked} image={icon} />
                  </div>
                  <div
                    className={
                      aspectRatio < 1 ? "add-button portrait" : "add-button"
                    }
                    onClick={handleSortIndex}
                  >
                    <Button active={sortingIndexChecked} image={sortingIcon} />
                  </div>
                  <div
                    className={
                      aspectRatio < 1 ? "add-button portrait" : "add-button"
                    }
                    onClick={handleGetDocuments}
                  >
                    <Button active={folderClicked} image={folderIcon} />
                  </div>
                </div>
              </div>
              <div
                className={
                  aspectRatio < 1
                    ? "folder-app-folders-wrapper portrait"
                    : "folder-app-folders-wrapper"
                }
              >
                <div className="folder-app-folders">
                  <div className="folder-app-subfolders">
                    {newFiles.map((file) => {
                      return (
                        <Folder
                          key={file.id}
                          setUpdateChecked={setUpdateChecked}
                          file={file}
                          updateChecked={updateChecked}
                          isAdding={true}
                          deleteFile={deleteFile}
                          addIntoFiles={addIntoFiles}
                          convertBytes={convertBytes}
                          findMemorySize={findMemorySize}
                          folderSize={folderSize}
                          setNewFiles={setNewFiles}
                          setViewDocument={setViewDocument}
                          viewDocument={viewDocument}
                          location={location}
                          aspectRatio={aspectRatio}
                          location_input={location_input}
                        />
                      );
                    })}
                  </div>
                  <hr className="folder-app-line"></hr>
                  {filteringChecked === 1 ? (
                    <AddDocumentEditor
                      location={location}
                      setNewFiles={setNewFiles}
                      setAddingChecked={setAddingChecked}
                      setViewDocument={setViewDocument}
                      viewDocument={viewDocument}
                      setFilteringChecked={setFilteringChecked}
                      setAddingDocument={setAddingDocument}
                    />
                  ) : (
                    <div className="folder-app-subfolders">
                      {files.map((file, index) => {
                        return (
                          <Folder
                            index={
                              sortingIndexChecked || sortingSizeChecked
                                ? Math.abs(index - files.length)
                                : index + 1
                            }
                            key={file.id}
                            setUpdateChecked={setUpdateChecked}
                            file={file}
                            updateChecked={updateChecked}
                            isAdding={false}
                            deleteFile={deleteFile}
                            convertBytes={convertBytes}
                            findMemorySize={findMemorySize}
                            folderSize={folderSize}
                            setFiles={setFiles}
                            setViewDocument={setViewDocument}
                            viewDocument={viewDocument}
                            location={location}
                            location_input={location_input}
                            aspectRatio={aspectRatio}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {viewDocument.value && (
        <div className="document-view-wrapper-admin">
          <div className="wrapper-header-folder-admin">
            <div className="full-screen-admin" onClick={handleResetView}>
              <Button activation={true} typeButton={typeButton}>
                <UndoIcon />
              </Button>
            </div>
            <div className="document-title-admin">{viewDocument.name}</div>
          </div>

          {!isAndroid && !isIOS ? (
            <iframe src={adminDocsUrl + viewDocument.data} height="92%" width="100%" />
          ) : (
            viewDocument.data !== "" && (
              <MobilePDFReader
                url={viewDocument.data}
                height="90%"
                width="100%"
              ></MobilePDFReader>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default FolderLocation;
